import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ standalone: false, selector: '[align-height]' })
export class AlignHeight {
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	@Input('align-height') settings: any;

	// biome-ignore lint/correctness/noUnusedPrivateClassMembers: suppressed due to migration - should be fixed
	constructor(private _elementRef: ElementRef) {}

	ngOnInit() {
		let max = 0;
		let target = document.querySelectorAll('.' + this.settings.selector);

		if (!this.settings.desktop && µ.Is.Desktop()) return false;

		if (!this.settings.tablet && µ.Is.Tablet()) return false;

		if (!this.settings.phone && µ.Is.Phone()) return false;

		window.setTimeout(() => {
			for (let i = 0; i < target.length; i++) {
				(target[i] as HTMLElement).style.minHeight = 'auto';
			}

			if (µ.Is.Phone()) return;

			for (let i = 0; i < target.length; i++) {
				if (target[i].clientHeight > max) max = target[i].clientHeight;
			}

			for (let i = 0; i < target.length; i++) {
				(target[i] as HTMLElement).style.minHeight = max + 'px';
			}
		}, 10);
	}
}
